export const APP_NAME = 'SafeLock' as const
export const BASE_URL = (import.meta as ImportMeta & { env: Record<string, string> }).env['VITE_BASE_URL'] ?? '/'

/**
 * 사업 정보 (단일 출처).
 * TODO: 실제 사업 정보 확정 시 이 파일만 수정하면 사이트 전체(연락처 섹션, 푸터)에 반영됩니다.
 */
export const BUSINESS = {
  name: 'SafeLock',
  nameKo: '세이프락',
  phone: '010-5918-8245',
  email: 'safelock-door@gmail.com',
  address: '',
  serviceArea: '안양 · 의왕 · 군포 · 과천 · 수원 · 성남',
  hours: '연중무휴 09:00–20:00 (긴급 출동 상담 24시간)',
} as const
